import { render, staticRenderFns } from "./weChatSearch.vue?vue&type=template&id=b284e6a6&"
import script from "./weChatSearch.vue?vue&type=script&lang=js&"
export * from "./weChatSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports